import { useContext } from "react";

import {
  DocumentFiltersContext,
  type UseDocumentFiltersReturn,
} from "../contexts/DocumentFiltersContext";

export const useDocumentFilters = (): UseDocumentFiltersReturn => {
  const ctx = useContext(DocumentFiltersContext);
  if (!ctx) {
    throw new Error(
      "useDocumentFilters must be used within a DocumentFiltersProvider",
    );
  }
  return ctx;
};
